import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React, { useMemo } from 'react';
import { _ApplyproofBadgeWrapper, _ApplyproofLinkWrapper, _Card, _CardContentWrapper, _CardHeading, _RequirementDescription } from "../style";
import useRequirementAttachments from "../../hooks/useRequirementAttachments";
import useExternalLinks from "../../hooks/useExternalLinks";
import useAdditionalAttachments from "../../hooks/useAdditionalAttachments";
import useVerifiedDocument from "../../hooks/useVerifiedDocuments";
import ExternalLinksAdditionalAttachments from "../Components/ExternalLinksAdditionalAttachments";
import { _DocumentCardContents } from "./style";
import RequirementAttachments from "./RequirementAttachments";
import { formatCents, getCurrencySign } from "../../../../../util/common";
import { APPLYPROOF_BADGE as ApplyProofBadge } from "../../../../../util/cdnAssets";
export default function DocumentRequirement(_ref) {
  var row = _ref.row;
  var attachments = useRequirementAttachments(row.requirement.id);
  var verifiedDocument = useVerifiedDocument(row.requirement.id);
  var externalLinks = useExternalLinks(row.requirement.id);
  var additionalAttachments = useAdditionalAttachments(row.requirement.id);
  var applyproofLink = useMemo(function () {
    return verifiedDocument ? "https://www.applyproof.com/".concat(verifiedDocument.id) : null;
  }, [verifiedDocument]);
  var requirementTitle = useMemo(function () {
    var requirement = row.requirement;
    var originalTitle = requirement.title;
    if (row.type !== 'receiptRequirement') return originalTitle;
    if (!requirement.currency_amount || !requirement.currency_amount.amount_cents) return originalTitle;
    var currencySign = getCurrencySign(requirement.currency_amount.currency);
    var amountWithCents = formatCents(requirement.currency_amount.amount_cents);
    var extraTitle = "(".concat(currencySign).concat(amountWithCents, " ").concat(requirement.currency_amount.currency, ")");
    return "".concat(originalTitle, " ").concat(extraTitle);
  }, [row]);
  var applyproofVerified = Boolean(row.requirement.applyproof_compatible);
  var hasExternalLinkOrAdditionalAttachments = externalLinks.length > 0 || additionalAttachments.length > 0;
  return /*#__PURE__*/React.createElement(_Card, null, /*#__PURE__*/React.createElement(_DocumentCardContents, null, /*#__PURE__*/React.createElement(_CardContentWrapper, null, /*#__PURE__*/React.createElement(_CardHeading, null, requirementTitle), /*#__PURE__*/React.createElement(_RequirementDescription, {
    dangerouslySetInnerHTML: {
      __html: row.requirement.description
    } // Descriptions can be HTML
  }), applyproofVerified && /*#__PURE__*/React.createElement(_ApplyproofLinkWrapper, null, /*#__PURE__*/React.createElement("span", null, "ApplyProof Link:"), /*#__PURE__*/React.createElement("a", {
    href: applyproofLink,
    target: "_blank",
    rel: "noreferrer"
  }, applyproofLink)), hasExternalLinkOrAdditionalAttachments && /*#__PURE__*/React.createElement(ExternalLinksAdditionalAttachments, {
    externalLinks: externalLinks,
    additionalAttachments: additionalAttachments
  }), /*#__PURE__*/React.createElement(RequirementAttachments, {
    applyproofVerified: applyproofVerified,
    attachments: attachments,
    verifiedDocument: verifiedDocument
  })), applyproofVerified && /*#__PURE__*/React.createElement(_ApplyproofBadgeWrapper, null, /*#__PURE__*/React.createElement("img", {
    src: ApplyProofBadge,
    alt: "ApplyproofBadge"
  }))));
}